export const CONTROL_PERMISSIONS = [
  "control.dashboard.read",
  "control.members.read",
  "control.members.manage",
  "control.audit.read",
  "identity.requests.read",
  "identity.requests.decide",
  "moderation.read",
  "moderation.manage",
  "monetization.read",
  "monetization.manage",
] as const;

export type ControlPermission = (typeof CONTROL_PERMISSIONS)[number];
export type ControlRole = "owner" | "admin" | "operator" | "viewer";
export type ControlMemberStatus = "active" | "disabled";

export const CONTROL_ROLE_PERMISSIONS: Record<ControlRole, ControlPermission[]> = {
  owner: [...CONTROL_PERMISSIONS],
  admin: [...CONTROL_PERMISSIONS],
  operator: [
    "control.dashboard.read",
    "control.members.read",
    "control.audit.read",
    "identity.requests.read",
    "moderation.read",
    "moderation.manage",
    "monetization.read",
  ],
  viewer: [
    "control.dashboard.read",
    "control.members.read",
    "control.audit.read",
    "identity.requests.read",
    "moderation.read",
    "monetization.read",
  ],
};

export type ControlMember = {
  uid: string;
  role: ControlRole;
  permissions: ControlPermission[];
  status: ControlMemberStatus;
  displayName?: string;
  email?: string;
};

export function hasControlPermission(member: ControlMember | null, permission: ControlPermission) {
  return member?.status === "active" && member.permissions.includes(permission);
}
